import React from 'react';
import PropTypes from 'prop-types';
import UserInformation from './UserInformation';
import AccountSecurity from './AccountSecurity';

const SignupDetails = ({ values, ...props }) => {
  const titleClass = 'like-h3 m-b-3';

  const userInformation = (
    <UserInformation
      title={<h3 className={titleClass}>Account details</h3>}
      values={values}
      {...props}
    />
  );

  const accountSecurity = (
    <AccountSecurity
      title={<h3 className={titleClass}>Account security</h3>}
      values={values}
      {...props}
    />
  );

  return (
    <div className="signup-details">
      <div className="row">
        <div className="col-md-6">
          {userInformation}
        </div>

        <div className="col-md-6">
          {accountSecurity}
        </div>
      </div>
    </div>
  );
};

SignupDetails.propTypes = {
  values: PropTypes.object.isRequired,
};

export default SignupDetails;



// WEBPACK FOOTER //
// ./library/app/components/Signup/SignupDetails.js